module.exports = __webpack_public_path__ + "media/images/notifications/icon_not_7-e96d34b8597976b36f63a626f0176e79.svg";